import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("a4w_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("a4w_token");
      localStorage.removeItem("a4w_user");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const getToken = () => localStorage.getItem("a4w_token") || "";
export const getUser = () => {
  try { return JSON.parse(localStorage.getItem("a4w_user") || "null"); } catch { return null; }
};
export const setAuth = (token, user) => {
  localStorage.setItem("a4w_token", token);
  localStorage.setItem("a4w_user", JSON.stringify(user));
};
export const clearAuth = () => {
  localStorage.removeItem("a4w_token");
  localStorage.removeItem("a4w_user");
};

export const fmtEUR = (v) => new Intl.NumberFormat("pt-PT", { style: "currency", currency: "EUR" }).format(Number(v || 0));
export const fmtDate = (s) => {
  if (!s) return "—";
  try {
    const d = new Date(s);
    if (isNaN(d.getTime())) return s;
    return d.toLocaleDateString("pt-PT", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch { return s; }
};
export const fmtDateTime = (s) => {
  if (!s) return "—";
  try {
    const d = new Date(s);
    return d.toLocaleString("pt-PT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return s; }
};

export const SERVICE_TYPE_LABEL = {
  dominio: "Domínio",
  alojamento: "Alojamento Web",
  prestacao: "Prestação de Serviços",
};
